import styled from "styled-components";
import {mq} from "./util/media";

const ButtonWrapper = styled.a`

  background: #CEBFBF;
  color: #676060;


  transition: 0.3s ease-in-out;

  &:hover {
    color: #CEBFBF;
    background: #676060;
    cursor: pointer;
  }

  letter-spacing: 0.5px;

  padding: 0 1rem;
  height: 41px;
  border-radius: 40px;

  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  width: fit-content;
  text-decoration: none;
  white-space: nowrap;

  ${mq.lt.md} {
    height: 34px;
    font-size: 15px;

  }

  ${mq.lt.sm} {
    height: 26.47px;
    font-size: 9px;
    padding:0 0.7rem;
  }
`

function Button (props) {
  return (
    <ButtonWrapper href="/webapp" target="_blank">
      {props.children}
    </ButtonWrapper>
  )
}

export default Button;